import React from "react";
import PropTypes from "prop-types";
import { Field, Hint, Input, Label } from "@zendeskgarden/react-forms";
import { Datepicker } from "@zendeskgarden/react-datepickers";
import styled from "styled-components";

const Container = styled('div')`
  margin-top: 3rem;
`;

const Grid = styled('div')`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
`

const DatepickerRangeField = ({ fromDate, onChangeFromDate, toDate, onChangeToDate}) => {
return (
  <Container>
    <Label>Select date range:</Label>
    <Grid>
      <Field>
        <Hint>From date:</Hint>
        <Datepicker value={fromDate} onChange={newDate => onChangeFromDate(newDate)} isCompact>
          <Input isCompact />
        </Datepicker>
      </Field>
      <Field>
        <Hint>To date:</Hint>
        <Datepicker value={toDate} onChange={newDate => onChangeToDate(newDate)} isCompact>
          <Input isCompact />
        </Datepicker>
      </Field>
    </Grid>
  </Container>
  );
};

DatepickerRangeField.propTypes = {
  fromDate: PropTypes.instanceOf(Date).isRequired,
  onChangeFromDate: PropTypes.func.isRequired,
  toDate: PropTypes.instanceOf(Date).isRequired,
  onChangeToDate: PropTypes.func.isRequired,
};

export default DatepickerRangeField;
